module.exports = __webpack_public_path__ + "static/media/main5_en.c82035fd.png";